import React from 'react';
import Panel from '../../../../../../components/outline/Panel';
import Table from '../../../../../../components/_table/Table';
import { columns } from './columns';
import Button from '../../../../../../components/Button';
import { reDirectPage } from '../../../../../../lib/common';
import { SUB_PAGE_CREATE_URL_PATH } from '../../../../../../constants/service/common/urlConstants';
import './HomeSubList.scss';

const HomeSubList = (props) => {
  const { pagination, subPageList, getList, updateSubPageStatus, deleteSubPage } = props;

  return (
    <div className="home-sub-list">
      <Panel>
        <div className="panel-header">
          <div className="title">서브 페이지 리스트</div>
          <div className="btn-area">
            <Button
              color="primary"
              text="페이지 등록"
              onClick={() => reDirectPage({ path: SUB_PAGE_CREATE_URL_PATH })}
            />
          </div>
        </div>

        <div className="panel-body">
          <Table
            columns={(utils) =>
              columns({
                updateSubPageStatus,
                deleteSubPage,
                ...utils,
              })
            }
            rowKey={(record) => record.id}
            pagination={pagination}
            list={subPageList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    </div>
  );
};

export default HomeSubList;
